import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleComponent } from './module.component';
import { AddModulComponent } from './add-modul/add-modul.component';
import { EditModulComponent } from './edit-modul/edit-modul.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { ProgramareModulComponent } from './programare-modul/programare-modul.component';



@NgModule({
    declarations: [
        ModuleComponent,
        AddModulComponent,
        EditModulComponent,
        ProgramareModulComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [ModuleComponent],
})
export class ModuleModule { }
